import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import AuthLayout, { AuthField, PASS_ERR, validPass } from './AuthLayout';
import { passwordApi } from '../api/services';
import { useAlerts } from '../custom/Alerts';

export default function NewPassword() {
    const { id, code } = useParams();
    const history = useHistory();
    const alerts = useAlerts();
    const [valid, setValid] = useState(false);
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        passwordApi.verify(id, code).then((ok) => setValid(ok === true)).catch(() => setValid(false));
    }, [id, code]);

    const e1 = !validPass(password) && PASS_ERR;
    const e2 = (!validPass(confirm) && PASS_ERR) || (password !== confirm && 'Lozinke se ne poklapaju');

    const submit = async (e) => {
        e.preventDefault();
        if (e1 || e2) return;
        setLoading(true);
        try {
            await passwordApi.update(id, code, password);
            alerts.success('Lozinka uspešno promenjena');
            setTimeout(() => history.replace('/login'), 2000);
        } catch { /* toast */ }
        setLoading(false);
    };

    return (
        <AuthLayout>
            {valid && (
                <form onSubmit={submit} noValidate>
                    <AuthField icon="bi-lock" error={e1}>
                        <InputText type="password" placeholder="Lozinka" value={password} onChange={(e) => setPassword(e.target.value)} maxLength={50} />
                    </AuthField>
                    <AuthField icon="bi-lock" error={e2}>
                        <InputText type="password" placeholder="Potvrdi lozinku" value={confirm} onChange={(e) => setConfirm(e.target.value)} maxLength={50} />
                    </AuthField>
                    <Button type="submit" label="Pošalji" loading={loading} disabled={loading || !!e1 || !!e2} />
                </form>
            )}
        </AuthLayout>
    );
}
